export const TASK_TAB = {
  MY_TASKS: 'MY_TASKS',
  ALL: 'ALL',
} as const;

export type TaskTab = (typeof TASK_TAB)[keyof typeof TASK_TAB];

export const PAGE_SIZE = 20;
